import { useCallback, useState } from 'react'
import { SelectOption } from 'components/form/Select/useSelect'
import apiClient from 'helpers/clients/apiClient'

export const useLocationSearch = () => {
  const [searchOptions, setSearchOptions] = useState<SelectOption[]>([])
  const [isSearching, setIsSearching] = useState(false)

  const searchLocations = useCallback(async (search: string) => {
    if (!search.trim()) {
      setSearchOptions([])
      return
    }

    setIsSearching(true)
    try {
      const response = await apiClient.searchLocations(search)
      if (response.success && response.data) {
        const options = response.data.map<SelectOption>((s) => ({
          label: s.text,
          value: `${s.lat ?? ''}:${s.long ?? ''}`,
        }))
        setSearchOptions(options)
      } else {
        setSearchOptions([])
      }
    } catch (error) {
      console.error('Error searching locations:', error)
      setSearchOptions([])
    } finally {
      setIsSearching(false)
    }
  }, [])

  return { searchOptions, isSearching, searchLocations }
}
